module.exports = __webpack_public_path__ + "img/character@2x.39e613f.webp";